import React from "react";
import ServicesHero from "../sections/ServicesHero";
import ServicesSection from "../sections/ServicesSection";
import Contact from "../sections/Contact";

const Services = () => {
  return (
    <div>
      <ServicesHero />
      <ServicesSection />
      <Contact />
    </div>
  );
};

export default Services;
